import './scss/index.scss';
import ComponentsFactory from 'foundation/components-factory';
import NbcAlertBarsComponent from './js/nbc-alert-bars.component';

ComponentsFactory.getInstance().define('nbc-alert-bars', NbcAlertBarsComponent);
